import Bout from "../../bout/Bout.js";
import Helper from "../../utils/helper/Helper.js";

export default class Skills {
	constructor() {
		this.player = Bout.that.player;
		this.checkUpd = new Object();
	}

	init() {
		this.mc = jQuery("#template-skills").clone();
		this.mc.attr("id", "skills" + Skills.ENUM++);


		this.build();

	}

	getClip() {
		return this.mc;
	}

	build() {
		let tmp = jQuery("#template-skill-cat").clone();
		tmp.attr("id", "skicat" + Skills.ENUM++);
		tmp.text("Combat/Defense");
		jQuery(".js-list", this.mc).append(tmp);
		let a = Skills.SKILLS;
		for (let x = 0; x < a.length; x++) {
			if (a[x].type === 0) {
				this.createSkill(a[x])
			}
		}

		tmp = jQuery("#template-skill-cat").clone();
		tmp.attr("id", "skicat" + Skills.ENUM++);
		tmp.text("Adventure");
		jQuery(".js-list", this.mc).append(tmp);

		for (let x = 0; x < a.length; x++) {
			if (a[x].type === 1) {
				this.createSkill(a[x])
			}
		}


	}

	createSkill(skill) {
		let tmp = jQuery("#template-skill").clone();
		tmp.attr("id", "skill" + Skills.ENUM++);
		jQuery(".js-icon", tmp).css("background-image", "url('./assets/ui/skills/" + skill.icon + "')");
		jQuery(".js-name", tmp).text(skill.name);
		let skl = this.player.getSkillValue(skill.id);
		let plain = this.player.getPlainSkillValue(skill.id);
		//console.log(plain)
		if (skl != plain) {
			jQuery(".js-value", tmp).html("<span>(" + Helper.toSkill(skl) + " </span>) " + Helper.toSkill(plain));
		} else {
			jQuery(".js-value", tmp).text(Helper.toSkill(plain));
		}
		jQuery(".js-value", tmp).addClass("js-" + skill.id);
		jQuery(".js-toggle", tmp).css("background-image", "url('./assets/ui/toggler.png')");
		jQuery(".js-head", tmp).on("click", this.toggle.bind(this, tmp));
		jQuery(".js-content", tmp).html(skill.desc);

		jQuery(".js-list", this.mc).append(tmp);
	}

	toggle(mc) {

		let content = jQuery(".js-content", mc);

		if (content.is(":visible")) {
			jQuery(".js-toggle", mc).removeClass("toggler-up")
			content.slideUp();
		} else {
			jQuery(".js-toggle", mc).addClass("toggler-up")
			content.slideDown();
		}

	}

	static getSkillName(skill) {
		let a = Skills.SKILLS;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id === skill) {
				return a[x].name;
			}
		}
		return "";
	}


	update() {
		//console.log("AAA")
		for (let x = 0; x < Skills.SKILLS.length; x++) {
			let skl = this.player.getSkillValue(Skills.SKILLS[x].id);
			let plain = this.player.getPlainSkillValue(Skills.SKILLS[x].id);
			if ((this.checkIfUpdate(Skills.SKILLS[x].id+"plain", plain))|| (this.checkIfUpdate(Skills.SKILLS[x].id, skl))) {
				/*jQuery(".js-" + Skills.SKILLS[x].id, this.mc).text(Helper.toSkill(skl));

				let skl = this.player.getSkillValue(skill.id);
				let plain = this.player.getPlainSkillValue(skill.id);*/
				//console.log(plain)
				if (skl != plain) {
					jQuery(".js-" + Skills.SKILLS[x].id, this.mc).html("<span>(" + Helper.toSkill(skl) + ") </span> " + Helper.toSkill(plain));
				} else {
					jQuery(".js-" + Skills.SKILLS[x].id, this.mc).text(Helper.toSkill(plain));
				}



			}
			//console.log(jQuery(".js-" + Skills.SKILLS[x].id, this.mc))
		}
	}

	checkIfUpdate(id, value) {
		if (this.checkUpd[id] !== value) {
			this.checkUpd[id] = value;
			return true;
		}
		return false;
	}

}

Skills.ENUM = 0;

Skills.SKILL_ARMSLORE = "ArmsLore";
Skills.SKILL_SWORDSMANSHIP = "Swordsmanship";
Skills.SKILL_FENCING = "Fencing";
Skills.SKILL_MACECOMBAT = "MaceCombat";
Skills.SKILL_TACTICS = "Tactics";
Skills.SKILL_ARMOURPROFICIENCY = "ArmourProficiency";
Skills.SKILL_PARRYING = "Parrying";
Skills.SKILL_MINING = "Mining";
Skills.SKILL_COOKING = "Cooking";
Skills.SKILL_CAMPING = "Camping";
Skills.SKILL_REMOVETRAP = "RemoveTrap";
Skills.SKILL_FISHING = "Fishing";
Skills.SKILL_ALCHEMY = "Alchemy";
Skills.SKILL_LUMBERJACK = "Lumberjack";


Skills.SKILLS = [
	{
		id: "ArmourProficiency",
		name: "Armour mastery",
		desc: "Allows the Hero to wear certain armours and shields.<br>Light armour: 25 skill points<br>Medium armour: 50 skill points<br>Heavy armour: 75 skill points",
		type: 0,
		icon: "skill_armourproficinecy.png"
	},
	{
		id: "ArmsLore",
		name: "Arms lore",
		desc: "+1% Damage bonus to all weapons for every 10 skill points.<br>+1 % Armour bonus to all pieces of armour for every 20 skill points.",
		type: 0,
		icon: "skill_armslore.png"
	},
	{
		id: "Fencing",
		name: "Fencing",
		desc: "Allows the Hero to equip increasingly powerful fencing weapons.<br>+1% Speed bonus to fencing weapons for every 10 skill points.",
		type: 0,
		icon: "skill_fencing.png"
	},
	{
		id: "MaceCombat",
		name: "Mace combat",
		desc: "Allows the Hero to equip increasingly powerful mace weapons.<br>+1% Damage bonus to mace weapons for every 10 skill points.",
		type: 0,
		icon: "skill_macecombat.png"
	},
	{
		id: "Parrying",
		name: "Parrying",
		desc: "This skill is checked during combat to determine whether an attack can be fully or partially blocked. Higher the skill, higher the chances.",
		type: 0,
		icon: "skill_parrying.png"
	},
	{
		id: "Swordsmanship",
		name: "Swordsmanship",
		desc: "Allows the Hero to equip increasingly powerful sword weapons.<br>+0.5% Damage bonus and +0.5% Speed bonus to sword weapons for every 10 skill points.",
		type: 0,
		icon: "skill_swordsmanship.png"
	},
	{
		id: "Tactics",
		name: "Tactics",
		desc: "Allows the Hero to get details about his foes like a list of the unit types and an overall estimate of the threat level of the incoming battle. Higher the skill, more accurate are the informations. ",
		type: 0,
		icon: "skill_tactics.png"
	},

	{
		id: "Alchemy",
		name: "Alchemy",
		desc: "Allows the Hero to create increasingly powerful potions (if he has the necessary ingredients).",
		type: 1,
		icon: "skill_alchemy.png"
	},
	{
		id: "Camping",
		name: "Camping",
		desc: "Allows the Hero to ignite a bonfire to camp and rest. A higher skill makes the camp more comfortable.",
		type: 1,
		icon: "skill_camping.png"
	},
	{
		id: "Cooking",
		name: "Cooking",
		desc: "Allows the Hero to prepare more complex and delicious dishes at the bonfire.",
		type: 1,
		icon: "skill_cooking.png"
	},
	{
		id: "Fishing",
		name: "Fishing",
		desc: "Allows the Hero to catch more rare fishes (you need a fishing rod).",
		type: 1,
		icon: "skill_fishing.png"
	},
	{
		id: "RemoveTrap",
		name: "Handle Traps",
		desc: "Allows the Hero to detect and to disarm a trap. A higher skill lowers the chances to trigger it.",
		type: 1,
		icon: "skill_removetrap.png"
	},
	{
		id: "Lumberjack",
		name: "Lumberjack",
		desc: "Allows the Hero to successfully harvest wood from a tree (you need an axe).",
		type: 1,
		icon: "skill_lumberjack.png"
	},
	{
		id: "Mining",
		name: "Mining",
		desc: "Allows the Hero to extract and to smelt ore (you need a pickaxe to extract and a forge to smelt).<br>0+ Iron Ore<br>15+ Copper Ore<br>30+ Shadow Ore<br>45+ Bronze Ore<br>60+ Silver Ore<br>75+ Golden Ore<br>80+ Verite Ore<br>90+ Valorite Ore<br>99+ Crystite Ore",
		type: 1,
		icon: "skill_mining.png"
	}
]